export const GRID_MAX_TEXT_LENGTH = 30;
